module.exports = __webpack_public_path__ + "static/img/introduceContent2.2a835c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceContent2.png
// module id = ePMf
// module chunks = 0